export const CHARGE_BUYER = 'Comprador';
export const CHARGE_ADMINISTRATIVE_OPERATIONS_MANAGER = 'Gerente Operaciones Corporativas';